<div class="container">
	<div class="header">
		<div class="header__content">
			<h1>Referrals</h1>
			<div class="search">
				<i
					class="mobile"
					class="fa-regular fa-ellipsis-vertical"
					nz-dropdown
					nzTrigger="click"
					[nzDropdownMenu]="menu"
				></i>
				<button
					class="web"
					nz-button
					nzShape="round"
					nz-dropdown
					nzTrigger="click"
					[nzDropdownMenu]="menu"
				>
					Actions <i nz-icon nzType="down"></i>
				</button>

				<nz-dropdown-menu #menu="nzDropdownMenu">
					<ul nz-menu>
						<li nz-menu-item (click)="export()">
							<i
								class="fa-regular fa-download"
								style="
									color: var(--color-brand);
									width: 15px;
									margin-right: 10px;
								"
							></i
							>Export
						</li>
						<li nz-menu-item (click)="invite()">
							<i
								class="fa-regular fa-user-plus"
								style="
									color: var(--color-brand);
									width: 15px;
									margin-right: 10px;
								"
							></i
							>Invite your friends
						</li>
						<li
							nz-menu-item
							href="https://uberticket.cloudstaff.com/my/ticket/de785657-7118-5627-838c-2edd87d7a4fd/create"
							target="_blank"
						>
							<a
								href="https://uberticket.cloudstaff.com/my/ticket/de785657-7118-5627-838c-2edd87d7a4fd/create"
								target="_blank"
								rel="noopener"
								style="color: var(--color-black)"
							>
								<i
									class="fa-regular fa-user-group"
									style="
										color: var(--color-brand);
										width: 15px;
										margin-right: 10px;
									"
								></i
								>Claim referrals
							</a>
						</li>
					</ul>
				</nz-dropdown-menu>
				<nz-input-group [nzSuffix]="suffixIconSearch">
					<input
						type="text"
						nz-input
						placeholder="Search"
						[(ngModel)]="searchKeyword"
						(ngModelChange)="this.searchText.next($event)"
					/>
				</nz-input-group>
				<ng-template #suffixIconSearch>
					<i nz-icon nzType="search"></i>
				</ng-template>
			</div>
		</div>
	</div>
</div>
<div class="container">
	<div class="referrals">
		@for (item of referrals; track item) {
			<div class="item">
				<div class="item__title">
					<div
						class="profile"
						[style.background-image]="
							'url(' + getProfilePix(item.imageUrl) + ')'
						"
					></div>
					<h1>{{ item.firstName }} {{ item.lastName }}</h1>
					<p>JX-{{ item.candidateId }}</p>
					<div style="margin-top: 10px">
						<i class="fa-regular fa-circle-check" style="color: #87dd7d"></i>
						Registered: {{ item.createdDate | date: 'dd-MMM-yyyy' }}
					</div>
				</div>
				<div class="item__content">
					@if (item.postingTitle) {
						<h1>
							{{ item.postingTitle.split(': ')[1] }}
						</h1>
					}
					@if (item.jrWorkLocation) {
						<p>{{ addSpaces(item.jrWorkLocation) }}</p>
					}
					@if (item.postingTitle) {
						<p>{{ item.postingTitle.split(': ')[0] }}</p>
					}
				</div>
				<div class="item__action">
					@if (!item.pipeline && !item.pipelineDate) {
						<label style="background-color: #a2b9cc">No Application</label>
					}
					@if (item.pipeline && item.pipelineDate) {
						<label [style.backgroundColor]="getStatus(item.pipeline)"
							>{{ item.pipeline }}:
							<span>{{ item.pipelineDate | date: 'dd-MMM-yyyy' }}</span></label
						>
					}
				</div>
			</div>
		}
		<nz-pagination
			class="pagination"
			nzShowSizeChanger
			[nzPageIndex]="pageIndex"
			[nzTotal]="referralCount"
			[nzPageSize]="pageSize"
			[nzPageSizeOptions]="pageSizeOption"
			(nzPageIndexChange)="pageIndexChanged($event)"
			(nzPageSizeChange)="pageSizeChanged($event, pageIndex)"
		/>

		@if (referrals.length === 0) {
			<div class="error-message">
				<img src="../../assets/images/no-results-referrals.svg" alt="" />
				<h1>No result found</h1>
			</div>
		}
	</div>
</div>

<nz-modal
	[(nzVisible)]="isInviteModalVisible"
	nzCentered
	(nzOnCancel)="handleCancel()"
	(nzOnOk)="handleOk()"
	nzWrapClassName="login-modal"
	nzWidth="600px"
	nzMaskClosable="false"
	nzKeyboard="false"
>
	<ng-container *nzModalContent>
		<div class="content-holder">
			<h1 class="modal-header">Invite your friends</h1>
			<p>
				Share this invitation link with your friends and on social media, and if
				they sign up to Cloudstaff Jobs through your link, you could get a great
				reward. For full terms and conditions,
				<a
					[href]="
						'https://docs.google.com/gview?url=' +
						baseUrl +
						'/assets/docs/CS%20TAG%20Frequently%20Asked%20Questions.pdf'
					"
					target="_blank"
					rel="noopener"
					>click here.</a
				>
			</p>
			<br />
			<button
				nz-button
				class="btn-next"
				nzType="primary"
				nzSize="large"
				nzShape="round"
				(click)="handleOk()"
			>
				Copy link
			</button>
		</div>
	</ng-container>
</nz-modal>
